/* eslint-disable react/no-unused-state */
/* eslint-disable no-shadow */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, FormGroup, Input, Label } from 'reactstrap';
import { addEnterpriseGroupChange } from '../actions/Companies';
import { addNumberFieldChange, getCompanyNumbers } from '../actions/Numbers';
import CompanyAutocomplete from './CompanyAutocomplete';

class AddEnterpriseGroupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
    };
    this.token = localStorage.getItem('jwtToken');
  }

  handleChange = ev => {
    const { name, value } = ev.target;
    const { addEnterpriseGroupChange } = this.props;
    this.setState({ [name]: value });
    addEnterpriseGroupChange({ name, value });
  };

  onAddedCompanyChange = async ({ name, value, suggestion }) => {
    const {
      addNumberFieldChange,
      user,
      addEnterpriseGroupChange,
      getCompanyNumbers,
      emails,
    } = this.props;
    if (suggestion) {
      await getCompanyNumbers(this.token, suggestion._id, false, 'enterpriseAdmin', true);
      addNumberFieldChange(name, suggestion._id);
      addNumberFieldChange('assignedTo', { email: emails[0], _id: user._id });
      addEnterpriseGroupChange({ name: 'company', value: suggestion._id });
    } else {
      addNumberFieldChange('company', value);
      addNumberFieldChange('userName', '');
      addEnterpriseGroupChange({ name: 'company', value: '' });
    }
  };

  render() {
    const { companies } = this.props;
    const { name } = this.state;

    return (
      <div className="container">
        <FormGroup row>
          <Label for="name" sm={6}>
            Group Name:
          </Label>
          <Col sm={8}>
            <Input
              required
              placeholder="Group Name..."
              type="text"
              name="name"
              value={name}
              onChange={this.handleChange}
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for="company" sm={6}>
            Management Company:
          </Label>
          <Col sm={8}>
            <CompanyAutocomplete
              placeholder="Filter Company..."
              companies={companies.docs || []}
              onChange={this.onAddedCompanyChange}
            />
          </Col>
        </FormGroup>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.AppState.user,
    name: state.UIState.companies.addedCompany.name,
    companies: state.AppState.companies,
    emails: state.UIState.numbers.addNumberFieldChange,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addEnterpriseGroupChange: companyData => dispatch(addEnterpriseGroupChange(companyData)),
    addNumberFieldChange: (name, value) => dispatch(addNumberFieldChange(name, value)),
    getCompanyNumbers: (token, id, uid, type, gflag) =>
      dispatch(getCompanyNumbers(token, id, uid, type, gflag)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddEnterpriseGroupForm);
